<template>
  <div
    :class="{
      [`${custom} !h-[--bb-spinner__height] !w-[--bb-spinner__width] !border-[--bb-spinner__border] !border-r-transparent dark:!border-[--bb-spinner__border--dark] dark:!border-r-transparent`]:
        !!custom,
    }"
    class="animate-spinner h-[3rem] w-[3rem] rounded-full border-[5px] border-gray-100 border-r-transparent dark:border-gray-700 dark:border-r-transparent"
  />
</template>

<script setup lang="ts">
const { custom = '' } = defineProps<{
  custom?: string;
}>();
</script>
